import React from "react";
// import CompanyLogo from "../assets/logo-white-2.webp";
import "./logo-2.css";
// import { IoMdSearch } from "react-icons/io";
// import PopupSearchBar from './PopupSearchBar'

export default function Logo() {
  //For Popup Search
  // const [popUpState, setPopUpState] = useState(false);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <img
        src="/images/logo-white-2.webp"
        alt="Company Logo"
        decoding="async"
        width="100"
        height="100"
        loading="eager"
        fetchpriority="high"
        style={{
          marginTop: "30px",
          height: "100px",
          width: "100px",
          position: "absolute",
          left: "5%",
          zIndex: 2,
        }}
      />
    </div>
  );
}
